import React from 'react';

import Button from '@atlaskit/button';

const ButtonDangerExample = (): React.JSX.Element => {
	return <Button appearance="danger">Danger button</Button>;
};

export default ButtonDangerExample;
